import { Navigate, Outlet, useLocation } from "react-router";
import { useRecoilValue } from "recoil";

import { selectedUserSchemeAtom } from "../../../atoms/user";
import { nav } from "../../../config/navigation";

const Alarm = () => {
	const location = useLocation();
	const selectedScheme = useRecoilValue(selectedUserSchemeAtom);
	const isTenant = selectedScheme?.role === "TENANT";

	if (isTenant) {
		const isAlertsRoute =
			location.pathname === nav.alarm.base ||
			location.pathname === `${nav.alarm.base}/` ||
			location.pathname.startsWith(`${nav.alarm.base}/${nav.alarm.alerts}`);
		if (!isAlertsRoute) {
			return <Navigate to={`${nav.alarm.base}/${nav.alarm.alerts}`} replace />;
		}
	}

	return <Outlet />;
};

export default Alarm;
